import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import localForage from 'localforage'; // defaults to localStorage for web and AsyncStorage for react-native
import thunk from 'redux-thunk';
import accessStore from './access';
import i18nStore from './i18n';
import draftStore from './draft';
import leagueStore from './league';
import messagesStore from './messages';
import homeStore from './home';

const reducers = combineReducers({
  accessStore,
  i18nStore,
  draftStore,
  leagueStore,
  messagesStore,
  homeStore,
});

// Real teams are re-fetched from the API on every page load, so they
// shouldn't be persisted between sessions (stale list otherwise). Reset on
// both write (inbound) and read (outbound) so any value already sitting in
// storage from before this change also gets discarded on rehydration.
// Rehydration replaces the whole draftStore slice (not a deep merge with
// reducer defaults), so realTeams must stay an array here rather than being
// omitted, or components reading it before the refetch completes will crash.
const stripRealTeams = (state) => ({ ...state, realTeams: [] });

const draftTransform = createTransform(stripRealTeams, stripRealTeams, {
  whitelist: ['draftStore'],
});

const persistConfig = {
  key: 'JOGA',
  storage: localForage,
  transforms: [draftTransform],
};
const persistedReducer = persistReducer(persistConfig, reducers);

export default () => {
  const store = createStore(
    persistedReducer,
    undefined,
    compose(applyMiddleware(thunk))
  );
  const persistor = persistStore(store);
  return { store, persistor };
};
